import { useEffect, useState } from "react";
import {
  ChevronDown,
  ChevronUp,
  Plus,
  Trash3Fill,
} from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import FormButton from "../../../Components/Buttons/FormButton";
import CustomDropdown from "../../../Components/Dropdown/CustomDropdown";
import FormSelect from "../../../Components/FormTag/FormSelect";
import InputFiled from "../../../Components/FormTag/InputFiled";
import Loader from "../../../Components/GlobalLoader/Loader";
import CommonModal from "../../../Components/Modals/CommonModal";
import Table from "../../../Components/Tables/Table";
import AsnAddLineLayout from "../../../Layout/AsnAddLineLayout";
import PageHeader from "../../../Layout/PageHeader";
import { lookUpService } from "../../../Services/common/lookup.service";
import { fetchMetaData } from "../../../Services/metadata.services";
import { CONTACT_NUM } from "../../../Shared/Helper/Constant";
import { CONTACT_PHONE_PATTERN_ERR_MSG } from "../../../Shared/Helper/ValidationMessage";
import {
  captializeString,
  formatDate,
  formatPhoneNumber,
  getLocalStorageItem
} from "../../../Utility/Utility";
import GetSvgIcon from "../../../assets/images/svgList";
import { SelcetOption } from "../../../model/common/apiResponse";
import { useStore } from "../../../store/Store";
import { useSearchStore } from "../../../store/search/searchStore";
import { createAsn } from "../model/AsnOverview.type";
import { deleteLineItem, getAsnDetails, submitASNForm, updateASNForm } from "../service/asnOverview.service";
import CommonConfirmationModal from "../../../Components/Modals/CommonConfirmationModal";
import { Line } from "../model/asnOverview.model";
import { DataState, RequestData } from "../model/AsnAddItem.type";
import useClientStore, { Client } from "../../../store/client/useClientStore";
import useEventSystem from "../../../events/useEventSystem";
import OverlayMessage from "../../Inventory/Overview/OverlayMessage";



export default function AsnOverviewAddEdit() {
  const { id } = useParams();
  const navigation = useNavigate();
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const [metaData, setMetaData] = useState<any>([]);
  const [createAsnData, setCreateAsnData] = useState<createAsn>(new createAsn());
  const [data, setData] = useState<DataState>({ supplier: [], warehouse: [], carriers: [] });
  const { setSearchTerm, resetSearch } = useSearchStore();
  const [handleInput, setHandleInput] = useState<string>("");
  const [searchInputValue, setSearchInputValue] = useState("");
  const [showAddLineModal, setShowAddLineModal] = useState(false);
  const [loading, setLoading] = useState(true); // Add loading state
  const [submitting, setSubmitting] = useState(false);
  const setSelectedItem = useStore((state) => state.setSelectedItem);
  const resetSelectedItems = useStore((state) => state.resetSelectedItems);
  const selectedItem = useStore((state) => state.selectedItem || []);
  const [showDeleteConfModal, setShowDeleteConfModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<{ item: any, index: number } | null>(null);
  const {getSelectedClient}= useClientStore();
  const [overlayMessage, setOverlayMessage] = useState("");
  const [isClientSelected, setIsClientSelected] = useState(false);
  const { emit } = useEventSystem();
  const [clientData,setClientData] = useState<any>(null);
  useEffect(() => {
    if(!clientData){
        setLoading(false);
        return;
    }
    setLoading(true);
    setSelectedItem([]);
    resetSelectedItems();
    resetSearch();
    setCollapseStates((prev) => prev.map(() => true));
    getMetaData().then(async() => {
      await fetchData().then(()=>{
           setLoading(false);
      });
    });
  }, [clientData]);
  useEffect(() => {
    const subscription = getSelectedClient().subscribe((client) => {
      setClientData(client);
      if (client && client.code!=="all") {
        emit('show_client_warning', false);
        setOverlayMessage("");
        setIsClientSelected(true);
      } else {
        emit('show_client_warning', true);
        setIsClientSelected(false);
        setOverlayMessage("Please select a Client");
      }
    });
    return () => subscription.unsubscribe();
  }, [getSelectedClient]);

  const handleOverlayClose = () => {
    emit('show_client_warning', false);
    return navigation(`/inbound/asn/overview`);
  }

  const handleDeleteConModal = (row: any, index: number) => {
    setItemToDelete({ item: row, index });
    if (id) {
      setShowDeleteConfModal(true);
    }
    else {
      handleLineItemDelete();
    }
  };

  const handleShow = () => {
    setShowAddLineModal(true);
  };

  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };

  //Handle UI line item delete
  const handleLineItemDelete = () => {
    if (itemToDelete) {

      const updatedItems = [...selectedItem];
      updatedItems.splice(itemToDelete.index, 1);
      // Reorder line numbers
      const reorderedItems = updatedItems.map((item, index) => ({
        ...item,
        line: (index + 1).toString(),
      }));
      setSelectedItem(reorderedItems);
    }
  }

  // Handle Line Item Delete for edit
  const handleConfirmDeleteForEdit = (isModalSubmit: boolean) => {
     if(!isModalSubmit){
      setShowDeleteConfModal(false);
      return;
     }
     if (isModalSubmit && itemToDelete && id) {
      if(!itemToDelete.item.asn_id) {
        handleLineItemDelete();
        setShowDeleteConfModal(false);
        setItemToDelete(null);
        return;
      }
      deleteLineItem(itemToDelete.item.asn_id, itemToDelete.item.id).then((response) => {
        if (response.status === 200) {
          handleLineItemDelete();
          toast.success("Line item deleted successfully!", { duration: 2000 });
        } else {
          toast.error("Failed to delete line item!", { duration: 2000 });
        }
        setShowDeleteConfModal(false);
        setItemToDelete(null);
      })
    }
  };

  // Move useForm before data fetching
  const {
    handleSubmit,
    register,
    setValue,
    getValues,
    control,
    clearErrors,
    trigger,
    reset,
    formState: { errors, isValid },
  } = useForm<createAsn>({
    defaultValues: createAsnData,
    mode: "onChange",
  });

  // Add effect to update form when createAsnData changes
  useEffect(() => {
    if (createAsnData) {
      reset(createAsnData);
      Object.keys(createAsnData).forEach((key) => {
        setValue(key as keyof createAsn, createAsnData[key as keyof createAsn]);
      });
    }
  }, [createAsnData, reset, setValue]);

  const selectedSupplier = (supplier: any) => {
    const contact_name = supplier.suuplier_name;
    const contact_phone = supplier.supplier_contact_phone;

    setValue("contactName", contact_name);
    setValue("contactNumber", contact_phone);

    validateAndClearErrors("contactName");
    validateAndClearErrors("contactNumber");
  };

  // API CALL TO FETCH THE META DATA
  const getMetaData = async () => {
    try {
      fetchMetaData().then((response) => {
        setMetaData(response.data.form_columns);
      });
    } catch (error) {
      console.error("Something went wrong while fetching MetaData: ", error);
    }
  };

  useEffect(() => {
    if (id) {
      getAsnDetails(id).then((response) => {
        const data = response?.data;
        setCreateAsnData({
          supplier: data?.supplier?.id ?? "",
          warehouse: data?.warehouse?.id ?? "",
          reference1: data?.reference_1?.toString() ?? '',
          reference2: data?.reference_2?.toString() ?? '',
          contactName: data?.supplier_contact_name?.toString() ?? '',
          contactNumber: data?.supplier_contact_phone?.toString() ?? '',
          tracking: data?.tracking_number?.toString() ?? '',
          expectedDate: data?.expected_arrival_date ? new Date(data.expected_arrival_date).toISOString().split('T')[0] : '',
          carrierName: data?.carrier?.id ?? "",
          specialInstruction: data?.special_instructions?.toString() ?? '',
        });

        // Set client data
        if (data?.client && data.client.id && data.client.code && data.client.name) {
          const clientData = {
            id: data.client.id,
            code: data.client.code,
            name: data.client.name,
            is_active: data.client.is_active ?? 1
          };
          setClientData(clientData);
          useClientStore.getState().onchangeClient(clientData);
        }
        
        const mappedLines = data?.lines?.map((line: Line) => ({
          asn_id: data.id,
          id: line.id,
          item: {
            id: line?.item?.id,
            code: line?.item?.code
          },
          code: line?.item?.code,
          description: line?.item?.description,
          uom_code: line?.uom_code,
          qty_on_hand: 0,
          ExpectedQty: line?.qty_expected?.toString() ?? '0',
          line: line?.line_number?.toString() ?? '0',
          unit_cost: line?.unit_cost,
          supplier_item_code: line?.supplier_item_code
        })) || [];

        setSelectedItem(mappedLines);
      });
    }
  }, [id]);



  // WAF to take labelName and filter through the metaData array of objects
  const fieldAttributesMapper = (labelName: string) => {
    if (labelName && metaData) {
      const filteredData = metaData.find(
        (data: any) => data.label === labelName
      );
      if (filteredData) {
        return filteredData;
      } else {
        return {
          display_text: captializeString(labelName),
          is_required: false,
          is_hidden: false,
        };
      }
    }
  };

  // Fetching Lookup data for warehouse, supplier and carrier
  const fetchData = async () => {
    try {
      const warehouseResponse = await lookUpService.warehouseLookup();
      const supplierResponse = await lookUpService.supplierLookup(clientData.id);
      const carriersResponse = await lookUpService.carriersLookup();

      const warehouseData: SelcetOption[] =
        warehouseResponse.data?.data?.results.map((obj: any) => ({
          label: obj.name,
          value: obj.id,
          code: obj.code,
        }));

      const supplierData: SelcetOption[] =
        supplierResponse.data?.data?.results.map((obj: any) => {
          return {
            label: obj.name,
            value: obj.id,
            code: obj.code,
            suuplier_name: obj.contact_name,
            supplier_contact_phone: obj.contact_phone,
          };
        });

      const carriersData: SelcetOption[] =
        carriersResponse.data?.data?.results.map((obj: any) => ({
          label: obj.name,
          value: obj.id,
          code: obj.code,
        }));

      setData({
        warehouse: warehouseData,
        supplier: supplierData,
        carriers: carriersData,
      });
      resetForm();
    } catch (error) {
    }
  };

  const resetForm = () => {
    if(id) return;
    reset(new createAsn());
    resetSelectedItems();
  }
  // Update the itemsDataParser to handle both edit and create cases
  const itemsDataParser = () => {
    return selectedItem.map((item: any) => ({
      ...(item.item?.id && { id: item.id }),
      item: {
        id: item.item?.id || (typeof item.id === 'number' ? item.id : parseInt(item.id)),
        code: item.item?.code || item.code
      },
      qty_expected: parseInt(item.ExpectedQty),
      uom_code: item.uom_code,
      unit_cost: parseFloat(item.item?.id ? item.unit_cost : item.cost) || null,
      supplier_item_code: item.supplier_item_code || null
    }));
  };

  // Handle Line Item addition in  the table
  const handleItemAddition = (selectedRows: any[]) => {
    if (selectedItem) {
      let lastLineNumber = selectedItem.length;
      const newItems = selectedRows.map((item) => ({
        id: item.id,
        code: item.code,
        name: item.name,
        uom_code: item.uom_code || "EA",
        qty_on_hand: item.qty_on_hand || 0,
        ExpectedQty: item.ExpectedQty || '0',
        line: (++lastLineNumber).toString(),
        cost: item.cost || null,
        supplier_item_code: item.supplier_item_code || null
      }));
      setSelectedItem([...selectedItem, ...newItems]);
    } 
  };

  const getClientData = async() => {
    if (clientData && Object.keys(clientData).length>0 && clientData.code!=='all') {
     return clientData;
    } else {
      toast.error("Client code is required!", { duration: 2000 });
      setSubmitting(false);
    }
  };


  const getCode = (value: string, sourceArray: any[]) => {
    const foundItem = sourceArray.find(
      (item: any) => parseInt(item.value) === parseInt(value)
    );
    return foundItem?.code ?? "";
  };

  const createRequestData = (
    formDta: any,
    clientData: any,
    data: any
  ): RequestData => {
    const requestData: RequestData = {
      client: {
        id: clientData.id,
        code: clientData.code,
      },
      supplier: {
        id: parseInt(formDta.supplier),
        code: getCode(formDta.supplier, data.supplier),
      },
      warehouse: {
        id: parseInt(formDta.warehouse),
        code: getCode(formDta.warehouse, data.warehouse),
      },
      expected_arrival_date: formDta.expectedDate,
      tracking_number: formDta.tracking,
      reference_1: formDta.reference1,
      reference_2: formDta.reference2,
      supplier_contact_name: formDta.contactName,
      supplier_contact_phone: formDta.contactNumber,
      lines: itemsDataParser(),
    };
    if (formDta.carrierName != undefined && formDta.carrierName != "") {
      requestData.carrier = {
        id: parseInt(formDta.carrierName),
        code: getCode(formDta.carrierName, data.carriers),
      };
    }
    if (formDta.specialInstruction) {
      requestData.special_instructions = formDta.specialInstruction;
    }

    return requestData;
  };

  const nextData: SubmitHandler<createAsn> = async (formDta) => { 
    if (submitting) return;
    setSubmitting(true);

    await getClientData();
    if (!clientData?.id || !clientData?.code || clientData.code==='all') {
      setSubmitting(false);
      return;
    }

    const requestData = createRequestData(formDta, clientData, data);

    try {
      const response = id
        ? await updateASNForm(requestData, id)
        : await submitASNForm(requestData);

      if (response.status === 200) {
        resetSelectedItems();
        resetSearch();
        toast.success(id ? "ASN updated successfully!" : "ASN created successfully!", { duration: 2000 });
        navigation("/inbound/asn/overview");
      } else {
        toast.error(id ? "An error occurred while updating ASN." : "An error occurred while creating ASN.", {
          duration: 2000,
        });
        setSubmitting(false);
      }
    } catch (error) {
      toast.error(id ? "An error occurred while updating ASN." : "An error occurred while creating ASN.", {
        duration: 2000,
      });
      setSubmitting(false);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancelBtn = () => {
    resetSelectedItems();
    resetSearch();
    navigation("/inbound/asn/overview");
  };

  const validateAndClearErrors = async (fieldName: keyof createAsn) => {
    const isValid = await trigger(fieldName);

    if (isValid) {
      clearErrors(fieldName);
    }
  };

  if (loading) {
    return <Loader />;
  }

  // Function to handle item selection, adding the selected item to the selectedItem array
  const handleItemSelect = (item: Record<string, any>) => {
    if (selectedItem) {
      const newItem = {
        ...item,
        line: (selectedItem.length + 1).toString(),
      };
      setSelectedItem([...selectedItem, newItem]);
    } else {
      setSelectedItem([{ ...item, line: "1" }]);
    }
  };

  const columnsConfig = [
    { columnName: "Item Code", selector: "code" },
    { columnName: "Item Name", selector: "name" },
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setHandleInput(value);
    setSearchInputValue(value);
  };

  const handleSearchTerm = () => {
    setSearchTerm(handleInput);
    setShowAddLineModal(true);
  };
  const handleEnterPress = (event: any) => {
    if (event.key === "Enter") {
      handleSearchTerm();
    }
  };

  const columns = [
    {
      name: "Line #",
      cell: (row: any, index: number) => <div>{row.code ? index + 1 : ""}</div>,
    },
    {
      name: "Item Code",
      cell: (row: any) =>
        selectedItem.some((selectedRow) => selectedRow.code === row.code) ? (
          <div>{row.code}</div>
        ) : (
          <>
            <div className="input-group rounded-pill col-auto w-50">
              <input
                type="text"
                placeholder="Search"
                className="form-control  border border-end-0 pe-0 search-input"
                value={handleInput}
                onChange={handleInputChange}
                onKeyDown={handleEnterPress}
              />
              <span
                className="input-group-text bg-white border border-start-0 rounded-end-pill cursor-pointer"
                onClick={handleSearchTerm}
              >
                {GetSvgIcon.GlobalSearchIcon}
              </span>
            </div>
          </>
        ),
    },
    {
      name: "Item Name",
      cell: (row: any) => <div>{row.name}</div>,
    },
    {
      name: "UOM",
      cell: (row: any) => <div>{row.uom_code ?? ""}</div>,
    },
    {
      name: "Expected Qty",
      cell: (row: any) => <div>{row.ExpectedQty ?? "-"}</div>,
    },
    {
      name: "",
      cell: (row: any, index: number) =>
        row.id && (
          <Trash3Fill
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteConModal(row, index);
            }}
          />
        ),
    },
  ];
  // Ensure a blank row always contains the CustomDropdown
  const blankRow = {
    line: "",
    ItemCode: (
      <CustomDropdown
        handleSelect={handleItemSelect}
        data={[]}
        selectableColumns={columnsConfig}
      />
    ),
    ItemName: "",
    UOM: "",
    ExpectedQty: "",
  };

  // Create a reusable label component
  const FieldLabel = ({ fieldName }: { fieldName: string }) => {
    const fieldMeta = fieldAttributesMapper(fieldName);
    return (
      <label className="fw-medium">
        {fieldMeta?.display_text}
        {fieldMeta?.is_required && <span className="text-danger ms-1">*</span>}
      </label>
    );
  };

  return (
    <>
      <Toaster />
      <div>
        {!isClientSelected ? 
        <OverlayMessage message={overlayMessage} onClose={handleOverlayClose} /> : 
        <PageHeader
        addUrl="/inbound/asn/overview/add"
        listUrl="/inbound/asn/overview"
        viewType={true}
      />
      }
      </div>
      
      <h5 className="text-start mt-1 mb-3">{id ? "Edit ASN" : "Create ASN"}</h5>
      <div className="my-2 bg-white rounded py-1 pb-4 px-2">
        <div className="d-flex justify-content-between">
          <div className="px-3 col-8">
            {collapseStates[0] ? (
              <div className=" d-flex justify-content-between my-3 px-2 "></div>
            ) : (
              <div className=" d-flex justify-content-between px-2 mt-3 ">
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Supplier
                  </small>

                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {
                      data?.supplier.find(
                        (s) =>
                          s.value ===
                          getValues("supplier")
                      )?.label ?? "-"
                    }
                  </span>
                </div>
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Warehouse
                  </small>
                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {
                      data?.warehouse.find(
                        (s) =>
                          s.value ===
                          getValues("warehouse")
                      )?.label ??"-"
                    }
                  </span>
                </div>
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Tracking #
                  </small>
                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {getValues("tracking") ?? "-"}
                  </span>
                </div>
                <div className="grid-item text-secondary fw-light">
                  <small className="grid-label fw-medium title-color">
                    Expected Date
                  </small>
                  <span className="grid-value font-size-15 fc-dark-blue fw-normal">
                    {getValues("expectedDate")
                      ? formatDate(getValues("expectedDate"))
                      : "-"}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(0)}
            >
              {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
        </div>
        {collapseStates[0] && (
          <form>
            <div className="d-flex px-2 gap-3">
              <div className="col-5 px-2">
                <FieldLabel fieldName="supplier" />
                <div className="mt-1">
                  <FormSelect
                    name="supplier"
                    autofocus={true}
                    tabIndex={1}
                    control={control}
                    optionList={data.supplier ?? []}
                    defaultValue={createAsnData.supplier}
                    selectedOption={selectedSupplier}
                    className="form-control p-0 "
                    placeholder="Select"
                    isSearchable={true}
                    // hidden={fieldAttributesMapper("supplier")?.is_hidden}
                    required={fieldAttributesMapper("supplier")?.is_required}
                  />
                </div>
              </div>
              <div className="col-5 px-2">
                <FieldLabel fieldName="warehouse" />
                <div className="mt-1">
                  <FormSelect
                    name="warehouse"
                    tabIndex={2}
                    control={control}
                    defaultValue={createAsnData.warehouse}
                    optionList={data.warehouse ?? []}
                    className="form-control p-0"
                    placeholder="Select"
                    isSearchable={true}
                    required={fieldAttributesMapper("warehouse")?.is_required}
                  // hidden={fieldAttributesMapper("warehouse")?.is_hidden}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex mt-3 px-2 gap-3">
              <div className="col-5 px-2">
                <FieldLabel fieldName="Reference 1" />
                <div className="mt-1">
                  <InputFiled
                    type="text"
                    tabIndex={3}
                    register={register}
                    name="reference1"
                    errors={errors.reference1}
                    className="form-control"
                    placeholder="Enter reference 1"
                    required={fieldAttributesMapper("Reference 1")?.is_required}
                    hidden={fieldAttributesMapper("Reference 1")?.is_hidden}
                    onChange={async () =>
                      await validateAndClearErrors("reference1")
                    }
                  />
                </div>
              </div>
              <div className="col-5 px-2">
                <FieldLabel fieldName="Reference 2" />
                <div className="mt-1">
                  <InputFiled
                    type="text"
                    tabIndex={4}
                    register={register}
                    name="reference2"
                    errors={errors.reference2}
                    className="form-control"
                    placeholder="Enter reference 2"
                    required={fieldAttributesMapper("Reference 2")?.is_required}
                    hidden={fieldAttributesMapper("Reference 2")?.is_hidden}
                    onChange={async () =>
                      await validateAndClearErrors("reference2")
                    }
                  />
                </div>
              </div>
            </div>
            <div className="d-flex mt-3 px-2 gap-3">
              <div className="col-5 px-2">
                <FieldLabel fieldName="Contact Name" />
                <div className="mt-1">
                  <InputFiled
                    type="text"
                    tabIndex={5}
                    register={register}
                    name="contactName"
                    errors={errors.contactName}
                    className="form-control"
                    placeholder="Enter contact name"
                    required={
                      fieldAttributesMapper("Contact Name")?.is_required
                    }
                    hidden={fieldAttributesMapper("Contact Name")?.is_hidden}
                    onChange={async (e: any) => {
                      setValue("contactName", e.target.value);
                      await validateAndClearErrors("contactName");
                    }}
                  />
                </div>
              </div>
              <div className="col-5 px-2">
                <FieldLabel fieldName="Contact Number" />
                <div className="mt-1">
                  <InputFiled
                    type="text"
                    tabIndex={6}
                    register={register}
                    name="contactNumber"
                    errors={errors.contactNumber}
                    pattern={{
                      type: CONTACT_NUM,
                      message: CONTACT_PHONE_PATTERN_ERR_MSG,
                    }}
                    className="form-control"
                    placeholder="000-000-0000"
                    required={
                      fieldAttributesMapper("Contact Number")?.is_required
                    }
                    hidden={fieldAttributesMapper("Contact Number")?.is_hidden}
                    onChange={async (e: any) => {
                      const formattedNumber = formatPhoneNumber(e.target.value);
                      setValue("contactNumber", formattedNumber);
                      await validateAndClearErrors("contactNumber");
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex mt-3 px-2 gap-3">
              <div className="col-5 px-2">
                <FieldLabel fieldName="Tracking #" />
                <div className="mt-1">
                  <InputFiled
                    type="text"
                    tabIndex={7}
                    register={register}
                    name="tracking"
                    errors={errors.tracking}
                    className="form-control"
                    placeholder="Enter Tracking #"
                    required={fieldAttributesMapper("Tracking #")?.is_required}
                    hidden={fieldAttributesMapper("Tracking #")?.is_hidden}
                    onChange={async () =>
                      await validateAndClearErrors("tracking")
                    }
                  />
                </div>
              </div>

              <div className="col-5 px-2">
                <FieldLabel fieldName="Expected Date" />
                <div className="mt-1">
                  <InputFiled
                    type="date"
                    tabIndex={8}
                    register={register}
                    name="expectedDate"
                    errors={errors.expectedDate}
                    className="form-control"
                    placeholder="Enter Expected Date"
                    required={
                      fieldAttributesMapper("Expected Date")?.is_required
                    }
                    hidden={fieldAttributesMapper("Expected Date")?.is_hidden}
                    onChange={async (e: any) => {
                      const date = e.target.value;
                      setValue("expectedDate", date);
                      await validateAndClearErrors("expectedDate");
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex mt-3 px-2 gap-3">
              <div className="col-5 px-2">
                <FieldLabel fieldName="Carrier Name" />
                <div className="mt-1">
                  <FormSelect
                    name="carrierName"
                    tabIndex={9}
                    control={control}
                    defaultValue={createAsnData.carrierName}
                    optionList={data.carriers ?? []}
                    className="form-control p-0 mt-1"
                    placeholder="Select"
                    required={
                      fieldAttributesMapper("Carrier Name")?.is_required
                    }
                    isSearchable={true}
                    onChange={async () =>
                      await validateAndClearErrors("carrierName")
                    }
                  />
                </div>
              </div>

              <div className="col-5 px-2">
                <FieldLabel fieldName="Special Instruction" />
                <div className="mt-1">
                  <InputFiled
                    type="text"
                    tabIndex={10}
                    register={register}
                    name="specialInstruction"
                    errors={errors.specialInstruction}
                    className="form-control"
                    placeholder="Enter instruction"
                    required={
                      fieldAttributesMapper("Special Instruction")?.is_required
                    }
                    hidden={
                      fieldAttributesMapper("Special Instruction")?.is_hidden
                    }
                    onChange={() => {
                      if (errors.specialInstruction) {
                        clearErrors("specialInstruction");
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      </div>
      <div className="mb-2 bg-white rounded py-1 px-4 d-flex flex-column h-100">
        <Table
          data={[...selectedItem, blankRow]}
          columns={columns}
          CheckboxStatus={false}
          isStripped={true}
          customClassName="transferDetailsTable"
        />

        <div className="d-flex align-items-center mt-auto mb-2">
          <div onClick={handleShow} className="d-flex align-items-center">
            <div className="cursor-pointer ms-2 me-2 mb-2 addline-icon d-flex align-items-center justify-content-center">
              <Plus />
            </div>
            <small className="cursor-pointer fw-bold mb-2">Add Line</small>
          </div>

          <CommonModal
            customClassName="header-border"
            modalSize="modal-xl"
            customClassNameForBody="line-item-modal-height"
            handleClose={() => {
              setShowAddLineModal(false);
              setHandleInput("");
              setSearchInputValue("");
              setSearchTerm("");
            }}
            show={showAddLineModal}
            heading="Add Line Items"
            backdrop={false}
            content={
              <AsnAddLineLayout
              clientId={clientData?.id}
                data={[]}
                handleClose={() => {
                  setShowAddLineModal(false);
                  setHandleInput("");
                  setSearchInputValue("");
                  setSearchTerm("");
                }}
                handleAddItem={handleItemAddition}
                initialSearchTerm={searchInputValue}
              />
            }
          />
        </div>
      </div>

      <div className="mt-auto bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={11}
            className="sph-btn me-4"
            handleClick={handleSubmit(nextData)}
            disabled={submitting}
          >
            Submit
          </FormButton>
          <FormButton
            tabIndex={12}
            className="sph-btn sph-shift me-4"
            handleClick={handleCancelBtn}
          >
            Cancel
          </FormButton>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <CommonConfirmationModal
        confirmBtnText="Delete"
        cancelBtnText="Cancel"
        onModalSubmit={handleConfirmDeleteForEdit}
        title="Delete Line Item"
        content={"Are you sure you want to delete this line item?"}
        show={showDeleteConfModal}
      />
    </>
  );
}
